import React from 'react';
import './UpcomingEvents.css';

// Import the event images
import agrifoodImg from '../../assets/images/event-agrifood.png';
import globalGrainImg from '../../assets/images/event-global-grain.png';

// Array of data for your upcoming events
const eventsData = [
  {
    image: agrifoodImg,
    title: 'AGRIFOOD NEXTGEN BUSINESS LEADERS SUMMIT',
    date: '12th & 13th December 2025',
    venue: 'Hyatt | Alila Diwa Goa',
    description: 'A pivotal event in driving India\'s economic growth, contributing significantly to the country\'s GDP. The outlook for the Indian AgriFood industry remains strong, driven by rising demand in key sectors such as food processing, export, and technology integration. Transforming Legacy into Global Leadership.'
  },
  {
    image: globalGrainImg,
    title: 'G2F2 GLOBAL GRAIN FOOD & FEED 2025',
    date: '12th & 13th December 2025',
    venue: 'Hyatt | Alila Diwa Goa',
    description: 'Harvesting Opportunities, Powering the Future of Food & Feed Through Technology and Trade. A premier platform addressing challenges in India infrastructure and agricultural sectors, the summit focuses on price volatility, raw material trends, and supply chain resilience.'
  }
];

const UpcomingEvents = () => {
  return (
    <section className="upcoming-events-section">
      <div className="upcoming-events-container">
        {eventsData.map((event, index) => (
          <div key={index} className="event-item">
            <div className="event-image-col">
              <img src={event.image} alt={event.title} />
            </div>
            <div className="event-text-col">
              <h3>{event.title}</h3>
              <p className="event-meta">
                <strong>Date:</strong> {event.date}<br />
                <strong>Venue:</strong> {event.venue}
              </p>
              <p className="event-description">{event.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default UpcomingEvents;